export default __webpack_public_path__ + "static/media/leadership.9f3c2299.svg";